<template>
	<v-container class="fill-height">
		<v-row justify="space-around">
			<v-col cols="4" class="text-center">
				<v-progress-circular v-if="!error" indeterminate color="primary"></v-progress-circular>
				<v-alert v-if="error" outlined type="warning" prominent border="left"> {{ error }} </v-alert>
			</v-col>
		</v-row>
		{{ url }}
	</v-container>
</template>

<script>
import api from '@/api';

export default {
	name: 'AppGateway',
	props: {
		serviceId: {
			type: String,
			required: true,
		},
	},
	data: () => ({
		error: '',
	}),

	methods: {},
	async mounted() {
		try {
			if (this.serviceId) {
				// 14.03.2022:
				// This component (AppGateway.vue) is not actually used as of now,
				// so the call to getServiceAuthUrl was not updated with the version param.
				throw new Error('Unsupported');
				// eslint-disable-next-line no-unreachable
				const resp = await api.getServiceAuthUrl(this.serviceId, this.$route.query);
				if (!resp.url) {
					throw new Error('URL not found');
				}
				window.location.replace(resp.url);
			} else {
				throw new Error('Invalid request');
			}
		} catch (e) {
			this.error = e.response ? e.message : 'Unable to proceed.';
			console.log(e);
		}
	},
};
</script>
